import type { Model } from "@lumen/shared";

const MAX_AGE_MS = 60_000;

/** One catalog per signed-in app session, shared by every view. */
export function createModelCatalog(fetchModels: () => Promise<Model[]>) {
  let models: Model[] = [];
  let loadedAt: number | undefined;
  let revision = 0;
  let pending: Promise<Model[]> | undefined;
  const listeners = new Set<() => void>();

  return {
    getSnapshot: () => models,
    subscribe(listener: () => void) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    invalidate() {
      loadedAt = undefined;
      revision++;
    },
    load(): Promise<Model[]> {
      if (pending) return pending;
      if (loadedAt !== undefined && Date.now() - loadedAt < MAX_AGE_MS)
        return Promise.resolve(models);
      const requestRevision = revision;
      pending = fetchModels()
        .then((rows) => {
          models = Array.isArray(rows) ? rows : [];
          loadedAt = requestRevision === revision ? Date.now() : undefined;
          listeners.forEach((listener) => listener());
          return models;
        })
        .finally(() => {
          pending = undefined;
        });
      return pending;
    },
  };
}
